import React, { CSSProperties, FC } from 'react';
import styles from './Thumbnail.module.css';

export interface ThumbnailProps {
  s?: CSSProperties;
  src: string;
  alt: string;
}

const Thumbnail: FC<ThumbnailProps> = ({ s = {}, src, alt }) => {
  const { width, height, ...rest } = s;

  const thumbnailTheme = {
    width: width ?? height,
    height: height ?? width,
    backgroundImage: `url("${src}")`,
    ...rest,
  };

  return (
    <div className={styles.thumbnail} style={thumbnailTheme} title={alt} />
  );
};

export default Thumbnail;
